<template lang="pug">
#menu.sticky
  b-modal#modal-bio(centered, scrollable, hide-header, hide-footer, size="lg")
    template(v-if="modalContent === 'about'")
      p.title Acerca de
      p.text.text-justify Antes de la creación de este archivo viviente, no había ningún lugar que encontrara, agregara, clasificara y resguardara los trabajos de los periodistas asesinados en México. Algunos de esos artículos, periódicos enteros, portales web o cuentas de redes sociales, estaban desapareciendo; corrían el riesgo de perderse para siempre. En DEFENSORES DE LA DEMOCRACIA trabajamos para encontrar esos trabajos, darles un lugar donde permanezcan resguardados y así honrar el legado de sus autores.
      p.text.text-justify Éste es un espacio de y para todos los mexicanos. Porque los asesinatos de periodistas representan una doble pérdida: la individual y la social. Además de perder a la persona, toda la sociedad deja de tener una fuente de información, una voz crítica que nos da herramientas para tomar decisiones como ciudadanos y exigir a nuestros gobernantes. Cuando matan a un reportero, nos quitan algo a todos.
      p.text.text-justify Al conservar estos fragmentos de historia, también estamos protegiendo nuestra memoria y cambiando el rumbo de nuestro futuro. DEFENSORES DE LA DEMOCRACIA es un acto de rebeldía en sí mismo. Nos rehusamos a dejar que el silencio o la censura sean quienes cuenten nuestra historia.
      p.text.text-justify Académicos, periodistas y activistas que busquen profundizar en los temas cubiertos por reporteros o en entender sus asesinatos pueden usar este archivo como fuente de información. El sitio contiene datos sobre el contexto sociopolítico de los lugares donde los reporteros trabajaban y donde fueron asesinados posiblemente por su labor. Dentro del portal, podrás encontrar datos como:
      ul
        li Alcalde y partido político;
        li Gobernador y partido político;
        li Presencia de grupos del crimen organizado;
        li Tasa de homicidios por cada 100 mil habitantes;
        li Nivel de rezago social;
        li Indicadores de poder adquisitivo en la localidad (capturado en el porcentaje de viviendas con acceso a una lavadora); y
        li Nivel educativo en la localidad (capturado en el porcentaje de personas analfabetas mayores a 15 años).
      //template(v-if="modalContent === 'gratitude'")
      p.text.text-justify Defensores de la Democracia fue creado por Alejandra Ibarra Chaoul, diseñado por Tim Robertson y Sonia Chai de Good Digital Culture, e implementado por Jorge Andrade y Angélica Miranda. Monserrat Narváez, Mikhail Yaroshevskiy, Jeff A. López y Shuai Hao estuvieron a cargo de la investigación y trabajo técnico. Este proyecto fue posible gracias a un Magic Grant del Instituto Brown y un regalo de Lila Gault y Bill Arp.
      //p.title Agradecimientos
      //p.text.text-justify Este proyecto fue posible gracias al apoyo y financiamiento del Brown Institute for Media Innovation, un instituto de las universidades de Columbia y Stanford. La generosa donación de Lila Gault y Bill Arp también hizo posible el desarrollo de este espacio.
      //p.text.text-justify Queremos agradecer la confianza y generosidad de los amigos y familiares de los periodistas asesinados en México que hemos logrado contactar.
      //p.text.text-justify Sin el trabajo de las siguientes personas, este proyecto no habría sido posible: 
      //p.text.text-justify La investigación hemerográfica de la Mtra. Monserrat Narváez; 
      //p.text.text-justify El trabajo de programación e investigación de Mikhail Yaroshevskiy; 
      //p.text.text-justify La labor de coordinación institucional de Jeff López; 
      //p.text.text-justify El trabajo de Shuai Hao y Melissa Nieto, quienes colaboraron como becarios del proyecto; 
      //p.text.text-justify La investigación de la Dra. Gloria Rojas quien aportó parte del archivo de Miroslava Breach Velducea y Javier Valdez Cárdenas.
      //template(v-if="modalContent === 'methodology'")
      p.title Metodología
      p.text.text-justify Antes de la creación de DEFENSORES DE LA DEMOCRACIA, los trabajos de los periodistas asesinados en México estaban desperdigados y, en algunos casos, corrían el riesgo de desaparecer. No había ningún lugar, ni físico ni virtual, que los agrupara. Encontrar y agrupas los trabajos ha sido un esfuerzo artesanal, que implica diferentes retos en cada caso. La vida y carrera de cada periodista tiene características diferentes y, antes que nada, había que conocer sus particularidades para después encontrar sus trabajos. Para crear este espacio comunitario que los conserva, llevamos a cabo la siguiente metodología:
      p.text.text-justify Nos basamos en los casos de periodistas y trabajadores de medios asesinados de 2000 a la fecha documentados por el Comité de Protección a Periodistas. Una vez seleccionados los casos, buscamos la mayor información posible de la carrera profesional de cada comunicador y llevamos a cabo una búsqueda de sus trabajos. Encontramos algunos en la Hemeroteca Nacional de México, incluyendo publicaciones de finales de los años 90 hasta 2017. Digitalizamos esos trabajos para extraer el texto de la imagen a fin de permitir búsquedas por palabra. Además de los archivos físicos, también logramos rescatar artículos de páginas de internet que se perdieron, pero quedaron congeladas parcialmente en capturas del Way Back Machine, un portal del Internet Archive. Finalmente, encontramos muchos trabajos en redes sociales y páginas de internet activas de donde extrajimos el texto para su conservación. Familiares y amigos de algunos periodistas también enviaron trabajos u orientaron la búsqueda del material.
      p.text.text-justify El archivo contiene una catalogación manual del tema que se cubrió en cada una de las notas, fotos, videos o programas de radio contenidos en este sitio. De esta manera, se puede observar la evolución de los temas cubiertos por los reporteros a lo largo del tiempo, así como hacer búsquedas puntales de estos trabajos. También se ofrece una clasificación adicional a manera de etiquetas que añaden mayor información sobre las notas.
      p.text.text-justify Los temas se agregaron en categorías. Éstas son:
      ul
        li Salud
        li Política
        li Noticias
        li Religión
        li Policiaca
        li Deportes
        li Educación
        li Medio Ambiente
        li Cultura y Sociedad
        li Economía y Laboral
        li Justicia y Derechos Humanos
      p.text.text-justify Además, existe una catalogación adicional por etiquetas que puntualizan la naturaleza de los temas generales. Las etiquetas son las siguientes:
      ul
        li En el caso de hechos violentos, todas las notas están catalogadas bajo la etiqueta policiaca, pero agrupándolas con base en una diferenciación por agencia:
        ul
          li Las notas de policiaca que abordan un evento trágico sin autor (suicidios, choques, avalanchas, incendios), llevan una etiqueta de “sucesos”.
          li Las notas de policiaca que abordan un evento violento con un autor individual o de menor escala (robo habitación, pelea en un bar, asalto, asesinato, violación), tienen una etiqueta de “nota roja”.
          li Las notas de policiaca que abordan un evento de seguridad nacional o narcotráfico (noticias del ejército, balaceras, incautaciones, fosas) tienen una etiqueta de “seguridad nacional/crimen organizado/narcotráfico”.
        li En los casos en donde las notas aborden violación sexual o violencia doméstica, la temática será “policiaca”, pero llevarán la etiqueta adicional de “violencia de género”.
        li En el caso de notas que traten sobre algo relacionado a gasolina o energéticos tienen la etiqueta de “hidrocarburos”.
        li Para las notas que traten sobre política, habrá dos etiquetas: “elecciones” y “corrupción”.
      //template(v-if="modalContent === 'sources'")
      p.title Fuentes
      ul
        li Acervo documental: creación propia.
        li Base de datos de tasa de homicidios por cada 100 mil habitantes: INEGI y Conapo.
        li Base de datos de rezago social: Coneval
        li Base de datos de porcentaje de población con acceso a lavadora: Coneval
        li Base de datos de porcentaje de población analfabeta mayor a 15 años: Coneval
        li Base de datos de presencia de cárteles por año (1990-2000) y municipio: Ríos V, Coscia M. Knowing where and how criminal organizations operate using google. CIKM. 2012;12 :1412-1421.
        li Base de datos de alcaldes y partido político: creación propia con información de Sistema Nacional de Información Municipal (SNIM).
        li Base de datos de gobernadores con partido político: creación propia con investigación de resultados electorales.
      //template(v-if="modalContent === 'english'")
      p.title English Information
      p.text.text-justify It seems counterintuitive, but it’s true: since Mexico transitioned into a democracy, it has become one of the most dangerous countries to be a reporter in the world. Between 2000 and 2018, the number of killed reporters and media workers was 104, according to the Committee to Protect Journalists. Of these crimes, 99% remain unsolved.
      p.text.text-justify In the face of this crisis, many journalists were becoming numbers, statistics of violence. Their works quickly transitioned into oblivion. That’s why we created DEMOCRACY FIGHTERS (DEFENSORES DE LA DEMOCRACIA, for its name in Spanish), a living archive that aggregates and preserves the works of journalists killed in Mexico.
      p.text.text-justify When a reporter is killed, the loss is double. We lose the individual and we lose their future work forever. We’re all deprived from that documentation of reality, that critical voice with its investigations and the information with which we make decisions to continue to participate as citizens strengthening our democracy.
      p.text.text-justify DEFENSORES DE LA DEMOCRACIA is a space for and of everyone, where we honor their memory and preserve our history.
      //template(v-if="modalContent === 'acknowledgements'")
      p.text.text-justify DEFENSORES DE LA DEMOCRACIA was created by Alejandra Ibarra Chaoul, designed by Tim Robertson and Sonia Chai at Good Digital Culture, and implemented by Jorge Andrade and Angélica Miranda. Research and technical assistance were also provided by Monserrat Narváez, Mikhail Yaroshevskiy, Jeff A. López and Shuai Hao. This project was made possible through a Magic Grant from the Brown Institute, and a gift from Lila Gault and Bill Arp.
      //p.title Acknowledgments
      //p.text.text-justify This project was made possible thanks to the support and funding of The Brown Institute for Media Innovation, a joint endeavor of the universities of Columbia and Stanford. A generous gift of Lila Gault and Bill Arp also made possible the creation of this space.
      //p.text.text-justify We want to thank the trust and generosity of those friends and family members of journalists who have been killed in Mexico that we were able to contact.
      //p.text.text-justify The work of the following people was paramount on building this project:
      //p.text.text-justify Monserrat Narváez in historic research;
      //p.text.text-justify Mikhail Yaroshevskiy in coding and programming;
      //p.text.text-justify Jeff López in institutional outreach and research;
      //p.text.text-justify Shuai Hao and Melissa Nieto who volunteered their time in coding and researching;
      //p.text.text-justify Gloria Rojas, Phd, who aggregated part of the archive of Miroslava Breach Velducea and Javier Valdez Cárdenas.
      //p.text.text-justify To read the translations for some of these journalistic works, you can visit the Mexican Translation Project: https://mexicanjournalismtranslationproject.wordpress.com.
    template(v-if="modalContent === 'know-more'")
      a(
        href="https://www.animalpolitico.com/defensores-de-la-democracia/",
        target="_blank"
      )
        p.title Visita nuestro blog
      p.title Sé parte del proyecto
      p.text.text-justify Por la naturaleza de la crisis de violencia contra periodistas en México, DEFENSORES DE LA DEMOCRACIA es un archivo viviente. Mientras sigan asesinando periodistas, el archivo seguirá creciendo. Queremos conservar todos los trabajos que todavía existen y aún no hemos encontrado. Si tienes algunos de estos textos, fotos, videos o programas de radio, por favor ponte en contacto con nosotros. Juntos, podemos seguir construyendo esta memoria colectiva.
      p.text.text-justify ¿Quieres contactarnos?
      p.text.text-justify Mándanos un correo a:&nbsp;
        a(href="mailto:contacto@ddld.mx") contacto@ddld.mx
  .desktop
    #menu-icon(
      :style="{ display: !openMenu ? 'block !important' : 'none !important' }",
      @click="openMenu = true"
    )
      p.m-0 &bull;
      p.m-0 &bull;
      p.m-0 &bull;
      p.m-0.text menú
  .mobile
    i#mobile-icon.fas.fa-bars(
      :style="{ display: !openMenu ? 'block !important' : 'none !important' }",
      @click="openMenu = true"
    )
  #right-menu.px-4.py-2.d-flex.flex-column(
    :style="{ display: openMenu ? 'flex !important' : 'none !important' }"
  )
    //p.mb-5.greater(@click="openMenu = false") >
    .desktop
      i.fas.fa-greater-than.mb-4.desktop(@click="openMenu = false")
    .mobile.close
      i.fas.fa-times.mb-4.mobile(@click="openMenu = false")
    router-link.menu-link(to="/")
      p.mt-2.mb-4(@click="openMenu = false") Inicio
    p.mt-2.mb-4(
      v-b-modal.modal-bio,
      @click="modalContent = 'about'; openMenu = false"
    ) Acerca de
    //p.mt-2.mb-4(
      v-b-modal.modal-bio,
      @click="modalContent = 'methodology'; openMenu = false"
    //) Metodología
    router-link.menu-link(to="/busqueda-avanzada")
      p.mt-2.mb-4(@click="openMenu = false") Búsqueda avanzada
    //router-link.menu-link(to="/voces-silenciadas")
      p.mt-2.mb-4(@click="openMenu = false") Podcast Voces Silenciadas
    //a(
      href="https://www.animalpolitico.com/defensores-de-la-democracia/",
      target="_blank"
    //)
      p.mt-2.mb-4 Visita nuestro blog
    //p.mt-2.mb-4(v-b-modal.modal-bio @click="modalContent = 'sources'; openMenu = false") Fuentes
    //p.mt-2.mb-4(v-b-modal.modal-bio @click="modalContent = 'gratitude'; openMenu = false") Agradecimientos
    p.mt-2.mb-4(
      v-b-modal.modal-bio,
      @click="modalContent = 'know-more'; openMenu = false"
    ) Conoce más
    //p.mt-2.mb-4(
      v-b-modal.modal-bio,
      @click="modalContent = 'english'; openMenu = false"
    //) English Information
    //p.mt-2.mb-4(v-b-modal.modal-bio @click="modalContent = 'acknowledgements'; openMenu = false") Acknowledgments
    img.ddld-logo.mt-3.mx-auto(src="/img/ddld_manchita_white.png")
    //h2.title.mt-3.px-2 DEFENSORES DE LA DEMOCRACIA
    //img.img-fluid.mt-3.brown-logo.mx-auto(src="/img/Brown-Logo.png" alt="Brown Institute Logo")
    social-sharing#social-sharing.mt-5(
      url="https://defensoresdelademocracia.mx",
      title="DEFENSORES DE LA DEMOCRACIA",
      description="Defensores de la Democracia es un archivo viviente que agrega y conserva los trabajos de los periodistas asesinados en México.",
      quote="Defensores de la Democracia es un archivo viviente que agrega y conserva los trabajos de los periodistas asesinados en México.",
      hashtags="periodistas, DDLD_MX",
      twitter-user="DDLD_MX",
      inline-template
    )
      .row.d-flex.justify-content-center
        network.col-2.d-flex.justify-content-center.align-items-center(
          network="facebook"
        )
          i.fab.fa-facebook
        network.col-2.d-flex.justify-content-center.align-items-center(
          network="twitter"
        )
          i.fab.fa-twitter
        network.col-2.d-flex.justify-content-center.align-items-center(
          network="whatsapp"
        )
          i.fab.fa-whatsapp
        network.col-2.d-flex.justify-content-center.align-items-center(
          network="telegram"
        )
          i.fab.fa-telegram
        network.col-2.d-flex.justify-content-center.align-items-center(
          network="email"
        )
          i.fas.fa-envelope
    a.download-link.mt-3(
      href="/pdf/comunicado-de-prensa.pdf",
      target="__blank"
    ) Comunicado de prensa
    a.download-link(href="/pdf/press-release.pdf", target="__blank") Press release
</template>

<script>
export default {
  name: "",
  data() {
    return {
      modalContent: "",
      openMenu: false,
    };
  },
};
</script>

<style lang="scss">
#menu {
  height: 100vh;
  z-index: 1000;
  &.sticky {
    position: fixed;
    top: 0;
    right: 0;
    display: block;
  }
  &.unsticky {
    position: relative;
    display: none;
  }
}

#modal-bio {
  @media (max-width: 767.98px) {
    .modal-content {
      border-radius: 0px !important;
      padding: 10px !important;
    }
  }
  .modal-content {
    background-color: #000000ee;
    border-radius: 0px;
    color: white;
    padding: 50px;
    a {
      color: white;
      text-decoration: underline;
    }
    .title {
      font-size: 30px;
    }
    .text,
    ul {
      font-size: 15px;
    }
  }
}
#menu-icon {
  position: fixed;
  top: 6px;
  right: 10px;
  width: 10px;
  cursor: pointer;
  p {
    line-height: 10px;
    font-size: 1.3rem;
    &.text {
      font-size: 12px;
      transform: rotate(270deg);
      //transform-origin: left top 0;
      line-height: 10px;
      margin-top: 30px !important;
      margin-right: 5px !important;
    }
  }
}

#mobile-icon {
  font-size: 1.7rem;
  position: fixed;
  top: 6px;
  right: 3px;
}

#right-menu {
  overflow-y: scroll;
  width: 320px; //25%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  background-color: #0a0a0a;
  .desktop {
    i.fas {
      color: white;
      font-size: 1rem;
      cursor: pointer;
    }
  }
  .mobile {
    display: flex;
    justify-content: flex-end;
    i.fas {
      font-size: 2rem;
      color: white;
    }
  }
  p {
    color: white;
    font-size: 20px;
    line-height: 14px;
    font-weight: 300;
    &.greater {
      font-size: 30px;
      font-weight: 400;
    }
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  a.download-link {
    color: white;
  }
  .menu-link {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
      color: #fff !important;
    }
  }
  .ddld-logo {
    height: 90px;
    width: 90px;
  }
  .title {
    color: #fff;
    -webkit-text-stroke: 1px #000;
  }
  .brown-logo {
    width: 20%;
  }
  #social-sharing {
    i {
      color: white;
      font-size: 20px;
    }
  }
}
.mobile.close {
  display: none !important;
}
@media (max-width: 767.98px) {
  #modal-bio {
    .modal-content {
      background-color: #000000ee;
      border-radius: 15px;
      color: white;
      padding: 15px;
      margin: 20px;
      .title {
        font-size: 30px;
      }
      .text,
      ul {
        font-size: 15px;
      }
    }
    .modal-backdrop {
      opacity: 0.3 !important;
    }
  }
  #right-menu {
    width: 100%;
    z-index: 1000;
    .mobile.close {
      display: inherit !important;
    }
  }
}
</style>
